// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Visual "required" marker for onboarding field labels (item 32,
 * ui-ux-spec.md: "All steps require an explicit answer or an explicit
 * none/not-applicable choice"). Rendered as a sibling to the field's
 * <label>, never nested inside it, so it never changes the label's
 * accessible name/textContent — required-ness is announced to assistive
 * tech once per step via OnboardingStepShell's legend line instead, so a
 * screen-reader user isn't told "star" on every single field.
 */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-danger">
      *
    </span>
  )
}
